import "../../columns.scss";
import styles from "./styles.module.scss";

interface Props {
  children?: any;
  width?: number | string;
  height?: number | string;
  type?: "row" | "flex" | "between" | "grid";
  centeredHorizontal?: boolean;
  centeredVertical?: boolean;
  direction?: "row" | "column";
}

export function ContainerAtom(props: Readonly<Props>) {
  let className = styles.container;

  if (props.centeredHorizontal) className += ` ${styles["container--centered-horizontal"]}`;

  if (props.centeredVertical) className += ` ${styles["container--centered-vertical"]}`;

  if (props.type) {
    const style = styles[`container--${props.type}`];
    className += ` ${style}`;
  }

  if (props.direction) {
    const style = styles[`container--direction${props.direction}`];
    className += ` ${style}`;
  }

  return (
    <div
      className={className}
      style={{
        width: props.width,
        height: props.height,
      }}
    >
      {props.children}
    </div>
  );
}
